<template>
  <div id="chat" class="absoluteItem">
    <p class="common-msg">
      {{ in_room_tip }}
    </p>

    <!-- <div class="chat-msg">
      <p class="flex-box">
        <img
          src="../../assets/blankimgcover.jpg"
          class="level imgBlock noevents-img"
        />
        <img
          src="../../assets/blankimgcover.jpg"
          class="sign imgBlock noevents-img"
        />
        <i class="name">的黑爹达</i>
        <i class="msg">再见再见再见</i>
      </p>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import cookie from "../../utils/cookie";
import "../../utils/topAction.css";
import live from "../../utils/live_share";
import wSocket from "../../utils/ws";

export default {
  name: "zhibochat",
  components: {},
  data() {
    return {
      djs: 0, //关闭礼物头像的倒计时器
      showLiwuHead: false,
      closeLiwuHdad: true,
      liwuImg: "",
      liwuID: "",
      gifts: [],
      songliwu: [], //送礼物的时候头像显示
      wsUlr: "",
      perInfo: [], //用户个人信息
      show: false, //显示贵宾
      see: 0, //0贵宾，1贡献，2观众
      in_room_tip:"",
    };
  },
  methods: {
    /**获取ws通道地址 */
    getWsAdd() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("config"), data, (res) => {
        _this.wsUlr = res.data.data.result.list.chat_add;
        _this.in_room_tip = res.data.data.result.list.in_room_tip;
        _this.creatWs();
      });
    },

    /**创建ws对象，并对接受的信息进行处理 */
    creatWs() {
      let _this = this;
      //获取用户信息之后，再调用这个接口
      let wsUlr = this.wsUlr;
      if (window.location.host == "wap-ris.3yakj.com") {
        wsUlr = "ws://192.168.4.228:5270"; //测试
      } else if (window.location.host == "localhost:8080") {
        wsUlr = "ws://192.168.4.228:5270"; //测试
      } else {
        wsUlr = this.wsUlr;
      }
      let ws = wSocket.able(wsUlr);
      ws.onopen = function () {
        let data = {
          action: "1",
          type:"j",
          roomnumber: _this.$route.query.roomnumber,
          botinfo: "",
          chatuserinfo: "",
        };

        //以游客身份登录
        let what = Math.random().toString(18).substr(2);
        data.nickname = "Guest_" + what;
        data.usernumber = what;
        data.userid = what;
        data.token = what;
        console.log(data);
        data = JSON.stringify(data);

        ws.send(data);
        //每10秒向服务器发送一次数据保持服务器和客户端的连接不断
        //也就是所谓的心跳
        setInterval(() => {
          ws.send("");
        }, 10000);
      };

      ws.onmessage = function (evt) {
        var res = JSON.parse(evt.data);
        console.log(res);
        if (res.type == "zuhe") {
          //循环组合
          res.data.zuhe.forEach(e => {
            if (e.type == 'j') {
              //欢迎进场
              live.into(e.data,"chat");
            }else if(e.type == 'b' && e.data.type == '1'){
              //发送礼物的消息
              live.getGift(e.data,"chat")
            }else if(e.type == 'upheat'){
              //通知父元素更新主播的热度值
              _this.$emit("up_heat",e.data.heat);
            }else if(e.type == "upponit"){
              //通知父元素更新主播的魅力值
              _this.$emit("uppoint",e.data.ponit);
            }
          });
        }else if(res.type == 'b' && res.data.type == '2'){
          //公屏聊天
          live.say(res.data,"chat");
        }else if(res.type == 'g'){
          //系统公告
          live.getGonggao(res.data,"chat");
        }  else if (res.type == "loginout") {
          //提示没有登录
          live.warning(res, "chat");
        } else if (res.type == "upponit") {
          //更新魅力值
           _this.$emit("uppoint",res.data.ponit);
        } else if (res.type == "upheat") {
          //更新热度
          _this.$emit("up_heat",res.data.heat);
        }else if (res.type == "roomout") {
          //退出直播间，并通知父组件关闭直播间播放状态
          live.warning(res, "chat");
          _this.$emit("end");
        }
      };
    },
  },
  mounted: function () {
    //获取ws通道地址
    this.getWsAdd();
  },
};
</script>

<style>
/**聊天框 */
#chat {
  width: 68%;
  left: 8px;
  bottom: 50px;
  height: 130px;
  overflow-y: auto;
}
#chat p {
  width: auto;
  background: rgba(0, 0, 0, 0.25);
  margin-bottom: 3px;
  border-radius: 8px;
  flex-wrap: wrap;
  padding: 2px 8px;
  align-items: center;
  line-height: 23px;
}
.common-msg {
  font-size: 12px;
  color: #fff;
  text-align: justify;
}
.chat-msg {
  display: inline-block;
}
.chat-msg .level {
  width: 28px;
  height: 12px;
  margin-right: 4px;
}
.chat-msg .sign {
  width: 45px;
  height: 12px;
  margin-right: 4px;
}
.chat-msg i {
  font-style: normal;
  font-size: 12px;
}
.chat-msg .name {
  color: #ebd18b;
  margin-right: 4px;
}
.chat-msg .msg {
  color: #fff;
}
.chat-msg .giftname{
  color: #ebd18b;
}
</style>
